export default class ModalVideo {
    constructor($urlVideo) {

        this.modal = document.querySelector('.modal-video')
        this.close = this.modal.querySelector('.close-modal')

        this.videoSection = this.modal.querySelector('.video')

        this.videoUrl = $urlVideo

        this.createFrame();

    }

    createFrame() {

        let iframe = document.createElement( "iframe" );
        iframe.setAttribute("frameborder", "0");
        iframe.setAttribute("allowfullscreen", "");
        iframe.setAttribute("allow", "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture");
        iframe.setAttribute("src", this.videoUrl);

        this.videoSection.innerHTML = "";
        this.videoSection.appendChild( iframe );

        this.modal.classList.add('active')
        this.destroyFrame()

    }

    destroyFrame() {

        this.modal.addEventListener('click', () => {
            this.modal.classList.remove('active')
            this.videoSection.innerHTML = ''
        })

    }

}